import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a985b61c8ab481f6aaf8584f46658741bb from "./generated-6dc204ca-041f-4a8c-903f-da60146bee16.json";

import abdaba1737c69f7cb03a35f4e628a3dbbb from "./generated-a481a0b6-4ca1-4f5d-b25e-58c01e3c8acb.json";

import ace124e47441b43b5937a81d7b316ece1b from "./generated-c37d931a-6214-4d74-bddc-449f71dab6fa.json";

import adc2341848c3355855bed3e6818647fbdb from "./generated-7d7d348b-3bb4-4069-8095-8d644b94c156.json";

import aa4eb8b62b16b508cc7d5fc729411c52cb from "./generated-61ce8323-ae93-4861-8763-468f7b43cae8.json";

import af9da5db2ca4605fd42fd7cf6ae0c251db from "./generated-f9b1442e-12a2-403b-aa39-4cca9c8683b0.json";

import a6de7743b74e8d84549bbfd3d00eba94db from "./generated-6c6dd33a-3227-439f-89f6-ed70e3bb5364.json";

import a2cbde76c2ed22f2f23695eb08101fea0b from "./generated-76a8a21b-0a67-4c2e-910e-01b939677ce8.json";

import a82886aeebcc4177954be5c4fabbe453db from "./generated-3bfc6877-775a-4217-b292-1488a22e224a.json";

import a962cb7a716450d983c211def2e9b28ecb from "./generated-db44f0fb-15cb-4c13-993d-b0f17d98345a.json";

import ae13db6fbaf4857b818ce80a9b588d424b from "./generated-36d466ce-cb61-4479-b3b5-24fc5900f979.json";

import a22cfe68fb3a148e42dc2956596d8f7fbb from "./generated-22885a3f-e204-4963-a941-6db5a9856c9a.json";

import a0a73a9cb2494a7d83a3eb4a028700dbdb from "./generated-205a1954-4a00-42a7-b9cd-e7400db623f0.json";

import a353fad5389e03af358b068e6d3b7fa9db from "./generated-a22a2a03-3b2a-46ff-8ac4-718d7ed24b7e.json";

import ab6dd2394d0db6281fe75deed6d761c2ab from "./generated-cd01a14d-5438-4207-83a9-3474342e5071.json";

import a1f57a309c07ef0389d3eb90c9c25c0afb from "./generated-a6ae0e4e-589c-4e59-9f0d-eb42f25e45c9.json";

import a6bdab1e32f37e23d16234c60f382b3cfb from "./generated-30636ab9-2d16-4fec-a642-bec5eaf92b98.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a985b61c8ab481f6aaf8584f46658741bb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(abdaba1737c69f7cb03a35f4e628a3dbbb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ace124e47441b43b5937a81d7b316ece1b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(adc2341848c3355855bed3e6818647fbdb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(aa4eb8b62b16b508cc7d5fc729411c52cb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(af9da5db2ca4605fd42fd7cf6ae0c251db);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a6de7743b74e8d84549bbfd3d00eba94db);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a2cbde76c2ed22f2f23695eb08101fea0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a82886aeebcc4177954be5c4fabbe453db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a962cb7a716450d983c211def2e9b28ecb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ae13db6fbaf4857b818ce80a9b588d424b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a22cfe68fb3a148e42dc2956596d8f7fbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a82886aeebcc4177954be5c4fabbe453db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a0a73a9cb2494a7d83a3eb4a028700dbdb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a353fad5389e03af358b068e6d3b7fa9db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a82886aeebcc4177954be5c4fabbe453db);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ab6dd2394d0db6281fe75deed6d761c2ab);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a1f57a309c07ef0389d3eb90c9c25c0afb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a6bdab1e32f37e23d16234c60f382b3cfb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ab6dd2394d0db6281fe75deed6d761c2ab);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */